"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepState = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = __importDefault(require("../Text"));
const Stepper_style_1 = require("./Stepper.style");
const emotion_theming_1 = require("emotion-theming");
var StepState;
(function (StepState) {
    StepState[StepState["completed"] = 0] = "completed";
    StepState[StepState["active"] = 1] = "active";
    StepState[StepState["todo"] = 2] = "todo";
})(StepState || (StepState = {}));
exports.StepState = StepState;
function Step({ text, number, state, isMobile, }) {
    const theme = emotion_theming_1.useTheme();
    let backgroundColor = theme.colors.white;
    let headerTextColor = theme.colors.primary;
    let mainTextColor = '#404457'; //TODO: missing color
    switch (state) {
        case StepState.completed:
            backgroundColor = theme.colors.lightGreen;
            headerTextColor = theme.colors.primary;
            mainTextColor = theme.colors.primary;
            break;
        case StepState.active:
            backgroundColor = theme.colors.primary; //TODO: missing color
            headerTextColor = isMobile ? theme.colors.white : theme.colors.secondary;
            mainTextColor = theme.colors.white;
            break;
        case StepState.todo:
            // -> use defaults
            break;
    }
    const containerStyle = {
        backgroundColor,
    };
    if (isMobile) {
        return (react_1.default.createElement("div", { style: { width: '100%' } },
            react_1.default.createElement(Stepper_style_1.StepContainerMobile, { style: containerStyle },
                react_1.default.createElement(Stepper_style_1.StepHeaderTextMobile, { style: { color: headerTextColor }, size: 15.3, bold: true }, number))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Stepper_style_1.StepContainer, { style: containerStyle },
            react_1.default.createElement(Stepper_style_1.StepHeaderText, { style: { color: headerTextColor }, size: 15.3, bold: true }, `STEP ${number}`),
            react_1.default.createElement("div", { style: { height: '8px' } }),
            react_1.default.createElement(Text_1.default, { style: { color: mainTextColor }, size: 20 }, text))));
}
exports.default = Step;
